import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.librarydrafts, {
    url: '/drafts',
    params: { title: 'Library -  Drafts' },
    views: {
      childcontent: {
        controller: [
          'flowModelApiService',
          'procedureApiService',
          'formThemesApiService',
          'APP_CONFIG',
          function (
            flowModelApiService: SharedAngular.FlowModelApiService,
            procedureApiService: SharedAngular.ProcedureApiService,
            formThemesApiService: SharedAngular.FormThemesApiService,
            APP_CONFIG: SharedAngular.APP_CONFIG
          ) {
            if (!flowModelApiService.flowModelsLoaded) {
              flowModelApiService.getFlowModels();
              if (APP_CONFIG.enableTagging) {
                flowModelApiService.getUsedTagsInFlowModels();
              }
            }
            if (
              APP_CONFIG.enableProcedures &&
              !procedureApiService.proceduresLoaded
            ) {
              procedureApiService.getProcedures();
              if (APP_CONFIG.enableTagging) {
                procedureApiService.getUsedTagsInProcedures();
              }
            }
            if (
              APP_CONFIG.allowWorkflow &&
              !formThemesApiService.formThemesLoaded
            ) {
              formThemesApiService.getFormThemes(true);
            }
          }
        ],
        template:
          '<runner-library-tabs></runner-library-tabs>' +
          '<library-drafts-grid></library-drafts-grid>'
      }
    }
  });
}
